import React from "react"
import styled from "styled-components"
import Button from "@irati/ui/src/Button"
import idHelper from "@irati/utils/id"
import FormattedMessage from "@irati/utils/lang"

const FloatingButton = styled(Button)`
  width: calc(100% - 60px);
  position: fixed;
  bottom: 30px;
  display: block;
  z-index: 999;
  max-width: 690px;
  margin-left: 15px;
  margin-right: 15px;
`

interface Props {
  onClick: () => any
}

const DealMobileContinue: React.FC<Props> = ({onClick, ...props}) => {
  const id = idHelper("mobile-continue", {props})
  return (
    <FloatingButton id={id} onClick={onClick} primary large>
      <FormattedMessage id="perks.containers.dealInfo.continue" />
    </FloatingButton>
  )
}

export default DealMobileContinue
